import { render, staticRenderFns } from "./testes-procedures.vue?vue&type=template&id=7e8b0f32&"
import script from "./testes-procedures.js?vue&type=script&lang=js&"
export * from "./testes-procedures.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports